import { object, string } from 'yup';
import { FormValue } from 'main/store/_utils/state';

export type Privacy = 'public' | 'private';

export type VideoData = {
    id: string;
    fileName: string;
    base64Data: string;
}

export type SharedVideoForm = {
    privacy: FormValue<Privacy>;
    title: FormValue;
    description: FormValue;
    video: FormValue<VideoData | null>;
}

export const privacySchema = string().required('プライバシーは必須です');
export const titleSchema = string();
export const descriptionSchema = string();
export const videoSchema = string().required('動画は必須です'); // TODO オブジェクトに対応

export const schema = object({
    privacy: privacySchema,
    title: titleSchema,
    description: descriptionSchema,
    video: videoSchema
});
